import { Link } from '@tanstack/react-router'

import { ArrowLeft } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'

export const DetailsActionsSkeleton = () => {
	return (
		<div className="flex w-full flex-col items-start justify-start gap-4">
			{Array.from({ length: 4 }).map((_, index) => (
				<Skeleton
					key={index}
					className="h-12 w-full rounded-lg rounded-tl-lg rounded-tr-lg border"
				/>
			))}
		</div>
	)
}

/** Sized to the `Pill` it stands in for — `h-5.5 rounded-full`, widest label. */
export const DetailsStatusSkeleton = () => {
	return <Skeleton className="h-5.5 w-24 rounded-full" />
}

export const DetailsMetadataSkeleton = () => {
	return (
		<div className="border-foreground my-6 flex w-full flex-col items-start justify-start gap-4 border-t border-b py-6">
			<div className="flex flex-col items-center justify-start gap-4">
				<DetailsMetadataItemSkeleton label="Trigger" />
				<DetailsMetadataItemSkeleton label="Started At" />
			</div>
			<div className="flex flex-col items-center justify-start gap-4">
				<DetailsMetadataItemSkeleton label="Started By" />
				<DetailsMetadataItemSkeleton label="Last Updated" />
			</div>
		</div>
	)
}

const DetailsMetadataItemSkeleton = ({ label }: { label: string }) => {
	return (
		<div className="text-muted-foreground flex w-80 flex-row items-center justify-start gap-2">
			{label}: <Skeleton className="h-5 w-32" />
		</div>
	)
}

export const PlaybookDetailsSkeleton = () => {
	return (
		<div className="flex w-full flex-col items-start justify-start">
			<DetailsHeaderSkeleton />
			<DetailsMetadataSkeleton />

			<div className="flex w-full flex-col items-start justify-start gap-4">
				<h2 className="text-lg font-semibold">Actions</h2>

				<DetailsActionsSkeleton />
			</div>
		</div>
	)
}

export const DetailsHeaderSkeleton = () => {
	return (
		<header className="flex w-full flex-row items-center justify-between">
			<div className="flex flex-row items-center gap-4">
				<Button
					variant="outline"
					size="icon"
					nativeButton={false}
					render={
						<Link
							to="/activity/playbooks"
							title="Return to Playbook Activities"
						>
							<ArrowLeft className="h-4 w-4" />
						</Link>
					}
				/>

				<div className="flex flex-col items-start justify-start gap-1">
					{/* Title */}
					<Skeleton className="h-8 w-96" />
					{/* Subtitle */}
					<Skeleton className="h-4 w-64" />
				</div>
			</div>

			<DetailsStatusSkeleton />
		</header>
	)
}
